import * as CryptoJS from 'crypto-js';

export class PkceUtils {
  private static readonly BYTE_LENGTH = 64;

  public static generateChallengeAndCodeVerifier() {
    const codeVerifier = PkceUtils.generateRandomString();
    const codeChallenge = PkceUtils.generateChallenge(codeVerifier);

    return {
      codeChallenge,
      codeVerifier,
    };
  }

  private static generateRandomString(): string {
    const randomWords = CryptoJS.lib.WordArray.random(PkceUtils.BYTE_LENGTH);

    return CryptoJS.enc.Hex.stringify(randomWords);
  }

  private static generateChallenge(codeVerifier: string): string {
    const hash = CryptoJS.SHA256(codeVerifier).toString(CryptoJS.enc.Base64);

    return PkceUtils.base64UrlEncode(hash);
  }

  private static base64UrlEncode(value: string): string {
    return value.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }
}
